if (!window.customElements.get('sales-feature-swiper')) {
  customElements.define('sales-feature-swiper', class extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.$section = null;
    }

    connectedCallback() {
        this.$section = $(this);
        
        // Load Swiper library if not already loaded
        if (!window.Swiper) {
            if (window.loadSwiper) {
                window.loadSwiper(() => {
                    this.initSwiper();
                });
                return;
            } else {
                const checkSwiper = setInterval(() => {
                    if (window.Swiper) {
                        clearInterval(checkSwiper);
                        this.initSwiper();
                    }
                }, 100);
                setTimeout(() => clearInterval(checkSwiper), 5000);
                return;
            }
        }
        
        this.initSwiper();
    }

    initSwiper() {
        // Initialize Swiper - Optimized for feature carousel
        this.swiper = new Swiper(this.$section.find(".swiper-container")[0], {
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false
            },
            pagination: {
                el: this.$section.find(".swiper-pagination")[0],
                clickable: true
            },
            navigation: {
                nextEl: this.$section.find(".swiper-button-next")[0],
                prevEl: this.$section.find(".swiper-button-prev")[0]
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                480: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                }
            }
        });

        this.setupSwiperEvents();
    }

    setupSwiperEvents() {
        // Left/Right button controls
        this.$section.find(".swiper-button-prev").on("click", () => {
            if (this.swiper) this.swiper.slidePrev();
        });

        this.$section.find(".swiper-button-next").on("click", () => {
            if (this.swiper) this.swiper.slideNext();
        });

        // Slide change event
        this.swiper.on("slideChange", () => {
            // Can add feature carousel specific logic here
        });

        // Autoplay progress bar
        this.swiper.on("autoplayTimeLeft", (swiper, time, progress) => {
            const pagination = this.$section.find(".swiper-pagination")[0];
            if (pagination) {
                pagination.style.setProperty("--swiper-progress", `${(1 - progress) * 100}%`);
            }
        });

        // Window resize event
        this.resizeHandler = () => {
            if (this.swiper) {
                this.swiper.update();
            }
        };
        
        window.addEventListener("resize", this.resizeHandler);
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }
        window.removeEventListener("resize", this.resizeHandler);
    }
  });
}